export default __webpack_public_path__ + "static/100_years_band-ea3c7a7ee6a86644b6c2bb71a0a3ac74.svg";